import React, { createContext, useContext, useState, useEffect } from 'react'
import { ThemeToggler as ThemeMode } from 'gatsby-plugin-dark-mode'
import * as b from "./bootstrap.module.css"

export const ThemeContext = createContext()

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(typeof window !== 'undefined' ? localStorage.getItem('theme') || 'light' : 'light');
  
  useEffect(() => {
    setTheme(localStorage.getItem('theme') || 'light')
  }, [])
  
  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

const ThemeToggle = () => {
  const { setTheme } = useContext(ThemeContext)

  return (
    <ThemeMode>
      {({ theme, toggleTheme }) => (
        <div className={["switch-input",b.dFlex].join(' ')}>
          <button 
            id="switch" 
            data-theme={theme}
            aria-label={theme === 'light' ? 'Włącz ciemny motyw kolorystyczny' : 'Włącz jasny motyw kolorystyczny'}
            onClick={() => { 
              const newTheme = theme === 'light' ? 'dark' : 'light';

              toggleTheme(newTheme);
              setTheme(newTheme);
            }}
          >
            <span className="sun-moon"/>
          </button> 
        </div>
      )}
    </ThemeMode>
  )
}

export default ThemeToggle;